/* Install Center — assets/install-center.js
 * Renders the guide library from the JSON in sections/install-center.liquid.
 * Shared helpers (window.InstallGuide) are also used by sections/product-install-guide.liquid.
 */
(function () {
  'use strict';

  var CATEGORY_ORDER = ['ATV', 'ATV/UTV', 'UTV', 'E-Bike'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function youtubeId(url) {
    if (!url) return '';
    var m = String(url).match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/|\/live\/)([A-Za-z0-9_-]{11})/);
    return m ? m[1] : '';
  }

  function toSeconds(t) {
    var parts = String(t).trim().split(':').map(function (n) { return parseInt(n, 10) || 0; });
    return parts.reduce(function (acc, n) { return acc * 60 + n; }, 0);
  }

  // "0:45 | Mount the bracket" per line
  function parseChapters(text) {
    if (!text) return [];
    return String(text).split(/\r?\n/).map(function (line) {
      var m = line.match(/^\s*(\d{1,2}(?::\d{2}){1,2})\s*[|\-–—]\s*(.+?)\s*$/);
      return m ? { time: m[1], seconds: toSeconds(m[1]), title: m[2] } : null;
    }).filter(Boolean);
  }

  // Bundle variants carry -1PK / -2PK suffixes; show the base SKU.
  function displaySkus(skus) {
    var seen = [];
    (skus || []).forEach(function (s) {
      var base = String(s).replace(/-\d+PK$/i, '');
      if (base && seen.indexOf(base) < 0) seen.push(base);
    });
    return seen.slice(0, 2).join(', ');
  }

  var ICON = {
    play: '<svg aria-hidden="true" viewBox="0 0 24 24" width="22" height="22"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>',
    doc: '<svg aria-hidden="true" viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5M9 13h6M9 17h6"/></svg>',
    down: '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v12M6 11l6 6 6-6M5 20h14"/></svg>',
    back: '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
  };

  // Lazy YouTube player: thumbnail until clicked, then a privacy-enhanced iframe.
  function playerHTML(id, title) {
    return '<div class="ic-player" data-ic-player data-yt="' + esc(id) + '" data-title="' + esc(title) + '">' +
      '<img class="ic-player__thumb" src="https://i.ytimg.com/vi/' + esc(id) + '/hqdefault.jpg" alt="" width="480" height="360" loading="lazy">' +
      '<button type="button" class="ic-player__play" aria-label="Play video: ' + esc(title) + '" data-ic-play>' + ICON.play + '</button>' +
      '</div>';
  }

  function playAt(player, seconds) {
    if (!player) return;
    var id = player.getAttribute('data-yt');
    var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1' + (seconds ? '&start=' + seconds : '');
    player.innerHTML = '<iframe src="' + src + '" title="' + esc(player.getAttribute('data-title')) + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
  }

  function bindPlayer(root) {
    root.addEventListener('click', function (e) {
      var play = e.target.closest('[data-ic-play]');
      if (play) { playAt(play.closest('[data-ic-player]'), 0); return; }
      var chap = e.target.closest('[data-ic-chapter]');
      if (chap) {
        root.querySelectorAll('[data-ic-chapter]').forEach(function (b) { b.removeAttribute('aria-current'); });
        chap.setAttribute('aria-current', 'step');
        var player = root.querySelector('[data-ic-player]');
        playAt(player, parseInt(chap.getAttribute('data-ic-chapter'), 10) || 0);
        if (player) player.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  function chaptersHTML(chapters) {
    if (!chapters.length) return '';
    return '<section class="ic-steps" aria-label="Jump to a step"><h2 class="ic-h2">Jump to a step</h2><ol>' +
      chapters.map(function (c, i) {
        return '<li><button type="button" class="ic-step" data-ic-chapter="' + c.seconds + '">' +
          '<span class="ic-step__time">' + esc(c.time) + '</span><span>' + (i + 1) + '. ' + esc(c.title) + '</span></button></li>';
      }).join('') + '</ol></section>';
  }

  window.InstallGuide = { youtubeId: youtubeId, parseChapters: parseChapters, chaptersHTML: chaptersHTML, playerHTML: playerHTML, bindPlayer: bindPlayer, esc: esc, ICON: ICON };

  function InstallCenter(root) {
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-ic-data]').textContent); } catch (err) { console.error('[install-center] bad data', err); }
    data.forEach(function (g) {
      g.ytId = youtubeId(g.youtube);
      g.hasVideo = !!g.ytId;
      g.hasPdf = !!g.pdf;
      g.skuLabel = displaySkus(g.skus);
      g.search = (g.title + ' ' + (g.skus || []).join(' ')).toLowerCase();
    });
    data = data.filter(function (g) { return g.hasVideo || g.hasPdf; });

    var cats = [];
    data.forEach(function (g) { if (cats.indexOf(g.category) < 0) cats.push(g.category); });
    cats.sort(function (a, b) {
      var ia = CATEGORY_ORDER.indexOf(a), ib = CATEGORY_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b);
    });
    cats.unshift('All');

    var state = { q: '', cat: 'All' };
    var el = {
      list: root.querySelector('[data-ic-list]'),
      detail: root.querySelector('[data-ic-detail]'),
      hero: root.querySelector('.ic-hero'),
      chips: root.querySelector('[data-ic-chips]'),
      grid: root.querySelector('[data-ic-grid]'),
      count: root.querySelector('[data-ic-count]'),
      empty: root.querySelector('[data-ic-empty]'),
      none: root.querySelector('[data-ic-none]'),
      search: root.querySelector('[data-ic-search]')
    };
    var supportUrl = root.getAttribute('data-support-url') || '';

    function card(g) {
      var media = g.hasVideo
        ? '<img src="https://i.ytimg.com/vi/' + esc(g.ytId) + '/mqdefault.jpg" alt="" width="320" height="180" loading="lazy">' +
          (g.length ? '<span class="ic-card__len">' + esc(g.length) + '</span>' : '')
        : '<span class="ic-card__doc">' + ICON.doc + '<span>PDF install guide</span></span>';
      var tags = (g.hasVideo ? '<span class="ic-tag ic-tag--video">' + ICON.play + 'Video</span>' : '') +
        (g.hasPdf ? '<span class="ic-tag">' + ICON.down + 'PDF</span>' : '');
      return '<a class="ic-card" href="#' + esc(g.handle) + '" aria-label="Open install guide: ' + esc(g.title) + '">' +
        '<span class="ic-card__media">' + media + '</span>' +
        '<span class="ic-card__body">' +
        '<span class="ic-eyebrow">' + esc(g.category) + '</span>' +
        '<span class="ic-card__title">' + esc(g.title) + '</span>' +
        (g.skuLabel ? '<span class="ic-sku"><span class="ic-sku__label">SKU:</span> ' + esc(g.skuLabel) + '</span>' : '') +
        '<span class="ic-tags">' + tags + '</span>' +
        '</span></a>';
    }

    function renderList() {
      // No guides published yet: hide search/filters and show the "on the way" note
      // rather than a misleading "No guides match that search".
      if (!data.length) {
        root.querySelector('.ic-search').hidden = true;
        el.list.querySelector('.ic-toolbar').hidden = true;
        el.grid.hidden = true;
        el.empty.hidden = true;
        if (el.none) el.none.hidden = false;
        return;
      }
      el.chips.innerHTML = cats.map(function (c) {
        return '<button type="button" class="ic-chip" aria-pressed="' + (c === state.cat) + '" data-ic-cat="' + esc(c) + '">' + esc(c) + '</button>';
      }).join('');
      var q = state.q.trim().toLowerCase();
      var results = data.filter(function (g) {
        return (state.cat === 'All' || g.category === state.cat) && (!q || g.search.indexOf(q) >= 0);
      });
      el.grid.innerHTML = results.map(card).join('');
      el.count.textContent = results.length === 1 ? '1 install guide' : results.length + ' install guides';
      el.empty.hidden = results.length > 0;
      el.grid.hidden = results.length === 0;
    }

    function tile(label, value) {
      return value ? '<div class="ic-tile"><div class="ic-tile__label">' + esc(label) + '</div><div class="ic-tile__value">' + esc(value) + '</div></div>' : '';
    }

    function listBox(title, items) {
      if (!items || !items.length) return '';
      return '<section class="ic-box"><h2 class="ic-h3">' + esc(title) + '</h2><ul>' +
        items.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul></section>';
    }

    function renderDetail(g) {
      var chapters = g.hasVideo ? parseChapters(g.chapters) : [];
      var pdfBtn = '<a class="ic-btn ic-btn--accent" href="' + esc(g.pdf) + '" target="_blank" rel="noopener" download>' + ICON.down + 'Download PDF</a>';
      var top = g.hasVideo ? playerHTML(g.ytId, g.title + ' install') :
        '<div class="ic-pdfhero"><span class="ic-pdfhero__icon">' + ICON.doc + '</span><div class="ic-pdfhero__body">' +
        '<h2 class="ic-h2">Step-by-step PDF install guide</h2><p>Print it or keep it open on your phone while you work.</p>' + pdfBtn + '</div></div>';
      var tiles = tile('Install time', g.time) + tile('Difficulty', g.difficulty) + tile('People needed', g.people);
      var related = data.filter(function (r) { return r.category === g.category && r.handle !== g.handle; }).slice(0, 6);

      el.detail.innerHTML =
        '<nav class="ic-crumbs" aria-label="Breadcrumb"><a class="ic-btn ic-btn--ghost" href="#">' + ICON.back + 'All guides</a>' +
        '<span aria-hidden="true">/</span><span>' + esc(g.category) + '</span><span aria-hidden="true">/</span><span class="ic-crumbs__here">' + esc(g.title) + '</span></nav>' +
        '<div class="ic-detail__cols"><div class="ic-detail__main">' + top +
        '<div class="ic-detail__head"><div class="ic-eyebrow">' + esc(g.category) +
        (g.skuLabel ? ' · <span class="ic-sku__label">SKU:</span> ' + esc(g.skuLabel) : '') + '</div>' +
        '<h1 class="ic-h1 ic-h1--detail" tabindex="-1" data-ic-focus>' + esc(g.title) + '</h1>' +
        (g.summary ? '<p class="ic-lede">' + esc(g.summary) + '</p>' : '') + '</div>' +
        (tiles ? '<div class="ic-tiles">' + tiles + '</div>' : '') +
        chaptersHTML(chapters) +
        '</div><aside class="ic-detail__side">' +
        listBox('Tools you’ll need', g.tools) + listBox('What’s in the box', g.box) +
        (g.hasVideo && g.hasPdf ? '<section class="ic-box"><h2 class="ic-h3">Prefer it on paper?</h2>' + pdfBtn.replace('Download PDF', 'Download PDF install guide') + '</section>' : '') +
        '<section class="ic-box"><h2 class="ic-h3">The product</h2><a class="ic-btn ic-btn--outline" href="' + esc(g.url) + '">View product page</a></section>' +
        '<section class="ic-box ic-box--dark"><h2 class="ic-h3">Stuck on a step?</h2><p>Send us your SKU and the step you’re on. We’ll get you sorted.</p>' +
        (supportUrl ? '<a class="ic-btn ic-btn--light" href="' + esc(supportUrl) + '">Contact support</a>' : '') + '</section>' +
        '</aside></div>' +
        (related.length ? '<section class="ic-related"><h2 class="ic-h2">More in ' + esc(g.category) + '</h2><div class="ic-related__grid">' +
          related.map(function (r) {
            return '<a class="ic-mini" href="#' + esc(r.handle) + '"><span class="ic-mini__media">' + (r.hasVideo ? ICON.play : ICON.doc) + '</span>' +
              '<span><span class="ic-mini__title">' + esc(r.title) + '</span><span class="ic-mini__meta">' +
              (r.hasVideo && r.hasPdf ? 'Video + PDF' : r.hasVideo ? 'Video' : 'PDF guide') +
              (r.skuLabel ? ' · <span class="ic-sku__label">SKU:</span> ' + esc(r.skuLabel) : '') + '</span></span></a>';
          }).join('') + '</div></section>' : '');
    }

    function route() {
      var handle = decodeURIComponent(location.hash.replace(/^#/, ''));
      var g = handle && data.filter(function (x) { return x.handle === handle; })[0];
      if (g) {
        renderDetail(g);
        el.list.hidden = true; el.hero.hidden = true; el.detail.hidden = false;
        root.scrollIntoView({ block: 'start' });
        var h = el.detail.querySelector('[data-ic-focus]');
        if (h) h.focus({ preventScroll: true });
      } else {
        el.detail.hidden = true; el.detail.innerHTML = '';
        el.list.hidden = false; el.hero.hidden = false;
      }
    }

    el.search.addEventListener('input', function () { state.q = el.search.value; renderList(); });
    el.chips.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ic-cat]');
      if (b) { state.cat = b.getAttribute('data-ic-cat'); renderList(); }
    });
    root.querySelector('[data-ic-clear]').addEventListener('click', function () {
      state.q = ''; state.cat = 'All'; el.search.value = ''; renderList(); el.search.focus();
    });
    el.detail.addEventListener('click', function (e) {
      var back = e.target.closest('a[href="#"]');
      if (back) { e.preventDefault(); history.pushState('', document.title, location.pathname + location.search); route(); }
    });
    bindPlayer(el.detail);
    window.addEventListener('hashchange', route);

    renderList();
    route();
  }

  function init() {
    document.querySelectorAll('[data-install-center]').forEach(function (root) {
      if (!root.__ic) { root.__ic = true; InstallCenter(root); }
    });
    document.querySelectorAll('[data-install-guide-product]').forEach(function (root) {
      if (!root.__ic) { root.__ic = true; bindPlayer(root); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
